(() => {
  const header = document.querySelector("[data-ir-header]");
  if (header) {
    const onScroll = () => {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile drawer ---------- */
  const drawer = document.querySelector("[data-ir-drawer]");
  const menuOpen = document.querySelector("[data-ir-menu-open]");
  if (drawer && menuOpen) {
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add("ir-drawer-open");
      menuOpen.setAttribute("aria-expanded", "true");
      const closeBtn = drawer.querySelector("[data-ir-drawer-close]");
      if (closeBtn) closeBtn.focus();
    };
    const close = () => {
      drawer.hidden = true;
      document.documentElement.classList.remove("ir-drawer-open");
      menuOpen.setAttribute("aria-expanded", "false");
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    };
    menuOpen.addEventListener("click", open);
    drawer.querySelectorAll("[data-ir-drawer-close]").forEach((el) => {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !drawer.hidden) close();
    });
  }

  /* ---------- Header search panel ---------- */
  const searchToggle = document.querySelector("[data-ir-search-toggle]");
  const searchPanel = document.querySelector("[data-ir-search-panel]");
  const searchInput = document.querySelector("[data-ir-search-input]");
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener("click", () => {
      const open = searchPanel.hasAttribute("hidden");
      if (open) {
        searchPanel.removeAttribute("hidden");
        searchToggle.setAttribute("aria-expanded", "true");
        if (searchInput) searchInput.focus();
      } else {
        searchPanel.setAttribute("hidden", "");
        searchToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---------- Predictive search ---------- */
  const suggest = document.querySelector("[data-ir-search-suggest]");
  if (searchInput && suggest && window.fetch) {
    let timer = 0;
    let ctl = null;
    const esc = (s) =>
      String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
    const sized = (url) => `${url}${url.includes("?") ? "&" : "?"}width=96`;
    const close = () => {
      suggest.hidden = true;
      suggest.innerHTML = "";
    };
    const run = async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) return close();
      if (ctl) ctl.abort();
      ctl = new AbortController();
      try {
        const res = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: ctl.signal, headers: { Accept: "application/json" } }
        );
        if (!res.ok) return;
        const data = await res.json();
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        const all = `<a class="ir-suggest__all" href="/search?type=product&q=${encodeURIComponent(q)}">See all results for “${esc(q)}”</a>`;
        suggest.innerHTML = items.length
          ? `<ul>${items
              .map(
                (p) =>
                  `<li><a href="${esc(p.url)}">${p.image ? `<img src="${esc(sized(p.image))}" alt="" width="48" height="48" loading="lazy">` : "<span></span>"}<span>${esc(p.title)}</span><span class="ir-suggest__price">$${Number(p.price).toFixed(2)}</span></a></li>`
              )
              .join("")}</ul>${all}`
          : `<p class="ir-suggest__empty">No matches yet. Try “mule”, “flat” or “dress”.</p>`;
        suggest.hidden = false;
      } catch {}
    };
    searchInput.addEventListener("input", () => {
      clearTimeout(timer);
      timer = setTimeout(run, 180);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !suggest.hidden) close();
    });
    document.addEventListener("click", (e) => {
      if (!suggest.hidden && !e.target.closest("[data-ir-search-panel]")) close();
    });
  }

  /* ---------- Collection filter + sort ---------- */
  const filterForm = document.querySelector("[data-ir-filters]");
  if (filterForm) {
    filterForm.querySelectorAll("[data-ir-filter-group]").forEach((box) => {
      box.addEventListener("change", () => {
        box.parentElement.querySelectorAll('input[type="hidden"]').forEach((member) => {
          member.disabled = !box.checked;
        });
      });
    });
    filterForm.querySelectorAll("[data-ir-filter-remove]").forEach((pill) => {
      pill.addEventListener("click", (e) => {
        e.preventDefault();
        const drop = new URLSearchParams(pill.getAttribute("data-ir-filter-remove"));
        const url = new URL(window.location.href);
        const keep = new URLSearchParams();
        url.searchParams.forEach((v, k) => {
          if (k === "page") return;
          if (drop.getAll(k).includes(v)) return;
          keep.append(k, v);
        });
        url.search = keep.toString();
        window.location.href = url.toString();
      });
    });
    filterForm.addEventListener("submit", () => {
      filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
        if (!input.value) input.disabled = true;
      });
    });
    const sortSelect = filterForm.querySelector("[data-ir-sort]");
    if (sortSelect) {
      sortSelect.addEventListener("change", () => {
        if (typeof filterForm.requestSubmit === "function") filterForm.requestSubmit();
        else filterForm.submit();
      });
    }
  }

  /* ---------- Gallery + lightbox ---------- */
  let galleryToVariant = null;
  const root = document.querySelector("[data-ir-gallery]");
  if (root) {
    const track = root.querySelector("[data-ir-gallery-track]");
    const slides = Array.prototype.slice.call(root.querySelectorAll("[data-ir-gallery-slide]"));
    const thumbs = Array.prototype.slice.call(
      root.querySelectorAll("[data-ir-gallery-thumb]")
    );
    const count = root.querySelector("[data-ir-gallery-count]");
    let index = 0;

    const mark = (i) => {
      index = i;
      thumbs.forEach((t, ti) => {
        t.setAttribute("aria-current", ti === i ? "true" : "false");
      });
      if (count) count.textContent = `${i + 1} / ${slides.length}`;
    };

    const setMain = (i, smooth) => {
      if (!track || !slides[i]) return;
      mark(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? "smooth" : "auto" });
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener("click", () => setMain(i, true));
    });

    if (track) {
      let raf = 0;
      track.addEventListener(
        "scroll",
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
            if (i !== index && slides[i]) mark(i);
          });
        },
        { passive: true }
      );
      window.addEventListener("resize", () => {
        track.scrollLeft = index * track.clientWidth;
      });
    }

    galleryToVariant = (variant) => {
      const fm = variant.featured_media;
      const fi = variant.featured_image || variant.image;
      let i = -1;
      if (fm && fm.id != null) i = slides.findIndex((s) => s.dataset.mediaId === String(fm.id));
      if (i < 0 && fi && fi.src) {
        const file = fi.src.split("?")[0].split("/").pop();
        i = slides.findIndex((s) => s.dataset.file === file);
      }
      if (i >= 0 && i !== index) setMain(i, true);
    };

    const jsonEl = root.querySelector("[data-ir-gallery-json]");
    const lightbox = root.querySelector("[data-ir-lightbox]");
    const openBtns = root.querySelectorAll("[data-ir-lightbox-open]");
    let images = [];
    if (jsonEl) {
      try {
        images = JSON.parse(jsonEl.textContent || "[]");
      } catch {
        images = [];
      }
    }

    if (lightbox && images.length && openBtns.length) {
      const lbImg = lightbox.querySelector("[data-ir-lightbox-img]");
      const lbCounter = lightbox.querySelector("[data-ir-lightbox-counter]");
      let lastFocus = null;
      let touchStartX = 0;
      let touchStartY = 0;

      const show = (i) => {
        if (!images.length) return;
        index = ((i % images.length) + images.length) % images.length;
        const item = images[index];
        lbImg.src = item.src;
        if (item.srcset) lbImg.srcset = item.srcset;
        lbImg.sizes = "100vw";
        lbImg.alt = item.alt || "";
        if (lbCounter) lbCounter.textContent = `${index + 1} / ${images.length}`;
        setMain(index, false);
      };

      const open = (i) => {
        lastFocus = document.activeElement;
        lightbox.hidden = false;
        document.documentElement.classList.add("ir-lightbox-open");
        show(typeof i === "number" ? i : index);
        const closeEl = lightbox.querySelector("[data-ir-lightbox-close]");
        if (closeEl) closeEl.focus();
      };

      const close = () => {
        lightbox.hidden = true;
        document.documentElement.classList.remove("ir-lightbox-open");
        if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      };

      openBtns.forEach((btn) => {
        btn.addEventListener("click", () => open(Number(btn.dataset.index || index)));
      });
      lightbox.querySelectorAll("[data-ir-lightbox-close]").forEach((el) => {
        el.addEventListener("click", close);
      });
      const lbAdd = lightbox.querySelector("[data-ir-lightbox-add]");
      if (lbAdd) {
        lbAdd.addEventListener("click", () => {
          const atc = document.querySelector('#IrProductForm [name="add"]');
          if (!atc || atc.disabled) return;
          if (atc.dataset.needSize) close();
          atc.click();
        });
      }

      const prevBtn = lightbox.querySelector("[data-ir-lightbox-prev]");
      const nextBtn = lightbox.querySelector("[data-ir-lightbox-next]");
      if (prevBtn) {
        prevBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          show(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          show(index + 1);
        });
      }

      document.addEventListener("keydown", (e) => {
        if (lightbox.hidden) return;
        if (e.key === "Escape") {
          e.preventDefault();
          close();
        } else if (e.key === "ArrowLeft" && images.length > 1) {
          e.preventDefault();
          show(index - 1);
        } else if (e.key === "ArrowRight" && images.length > 1) {
          e.preventDefault();
          show(index + 1);
        }
      });

      const stage = lightbox.querySelector("[data-ir-lightbox-stage]");
      if (stage && images.length > 1) {
        stage.addEventListener(
          "touchstart",
          (e) => {
            if (!e.changedTouches || !e.changedTouches[0]) return;
            touchStartX = e.changedTouches[0].clientX;
            touchStartY = e.changedTouches[0].clientY;
          },
          { passive: true }
        );
        stage.addEventListener(
          "touchend",
          (e) => {
            if (!e.changedTouches || !e.changedTouches[0]) return;
            const dx = e.changedTouches[0].clientX - touchStartX;
            const dy = e.changedTouches[0].clientY - touchStartY;
            if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
            if (dx < 0) show(index + 1);
            else show(index - 1);
          },
          { passive: true }
        );
      }
    }
  }

  /* ---------- Variant option selects → hidden id ---------- */
  const optionSelects = document.querySelectorAll("[data-ir-option]");
  const variantSelect = document.querySelector("[data-ir-variant]");
  const variantJson = document.querySelector("[data-ir-variant-json]");
  const atc = document.querySelector("[data-ir-atc]");
  const priceEl = document.querySelector(".ir-buybox__price");
  const chips = document.querySelectorAll("[data-ir-chip]");

  if (optionSelects.length && variantSelect && variantJson) {
    let variants = [];
    try {
      variants = JSON.parse(variantJson.textContent || "[]");
    } catch {
      variants = [];
    }

    let lastMediaKey = "";
    const sizeGroup = document.querySelector("[data-ir-size-group]");
    const sizeNeed = document.querySelector("[data-ir-size-need]");
    const stickyLabel = document.querySelector("[data-ir-sticky-submit]");
    const productForm = document.getElementById("IrProductForm");
    const sync = (fromUser) => {
      const chosen = Array.from(optionSelects).map((s) => s.value);
      const complete = chosen.every(Boolean);
      const pool = variants.filter((v) => {
        const opts = (v.options || []).map(String);
        return chosen.every((c, i) => !c || opts[i] === c);
      });
      const match = complete ? pool[0] : pool.find((v) => v.available) || pool[0];
      if (!match) return;
      if (complete) {
        variantSelect.value = String(match.id);
        Array.from(variantSelect.options).forEach((opt) => {
          opt.selected = opt.value === String(match.id);
        });
        if (sizeNeed) sizeNeed.hidden = true;
        if (sizeGroup) sizeGroup.classList.remove("is-needed");
        const stickyBar = document.querySelector("[data-ir-sticky-atc]");
        if (stickyBar) stickyBar.classList.remove("is-needed");
      }
      const anyAvailable = pool.some((v) => v.available);
      const sizeIndex = sizeGroup ? Number(sizeGroup.getAttribute("data-index")) : -1;
      const sizeShort = sizeIndex >= 0 && chosen[sizeIndex] ? chosen[sizeIndex].split(" (EU")[0] : "";
      if (atc) {
        if (complete) {
          delete atc.dataset.needSize;
          atc.disabled = !match.available;
          atc.textContent = match.available ? "Add to bag" : "Sold out";
        } else {
          atc.dataset.needSize = "1";
          atc.disabled = !anyAvailable;
          atc.textContent = anyAvailable ? "Choose your size" : "Sold out";
        }
      }
        if (stickyLabel) {
          if (!complete) stickyLabel.textContent = anyAvailable ? "Choose your size" : "Sold out";
          else stickyLabel.textContent = match.available ? (sizeShort ? `Add to bag · ${sizeShort}` : "Add to bag") : "Sold out";
        }
        const lbAdd = document.querySelector("[data-ir-lightbox-add]");
        if (lbAdd && atc) {
          lbAdd.textContent = atc.textContent;
          lbAdd.disabled = atc.disabled;
        }
      if (priceEl && match.price != null) {
        const now = priceEl.querySelector("[data-ir-price-now]");
        const was = priceEl.querySelector("[data-ir-price-was]");
        const save = priceEl.querySelector("[data-ir-price-save]");
        const price = Number(match.price);
        const cmp = Number(match.compare_at_price || 0);
        const onSale = cmp > price;
        if (now) now.textContent = `$${(price / 100).toFixed(2)}`;
        if (was) {
          was.hidden = !onSale;
          was.textContent = onSale ? `$${(cmp / 100).toFixed(2)}` : "";
        }
        if (save) {
          save.hidden = !onSale;
          save.textContent = onSale ? `Save ${Math.floor(((cmp - price) * 100) / cmp)}%` : "";
        }
        priceEl.classList.toggle("ir-buybox__price--sale", onSale);
      }
      // Follow the variant's photo only when the shopper changes it; page load keeps the lead photo.
      const feat = match.featured_media || match.featured_image || match.image;
      const mediaKey = feat ? String(feat.id || feat.src || "") : "";
      if (fromUser && mediaKey && mediaKey !== lastMediaKey && galleryToVariant) galleryToVariant(match);
      lastMediaKey = mediaKey;
      // mark unavailable chips for current partial selection
      chips.forEach((chip) => {
        const optIndex = Number(chip.getAttribute("data-option-index") || "0");
        const value = chip.getAttribute("data-value") || "";
        const trial = chosen.slice();
        trial[optIndex] = value;
        const any = variants.some((v) => {
          const opts = (v.options || []).map(String);
          return trial.every((c, i) => !c || opts[i] === c) && v.available;
        });
        chip.classList.toggle("is-unavailable", !any);
        chip.disabled = !any && chip.getAttribute("aria-pressed") !== "true";
      });
      document.querySelectorAll("[data-ir-sticky-chip]").forEach((mirror) => {
        const value = mirror.getAttribute("data-value") || "";
        const real = sizeGroup && sizeGroup.querySelector(`[data-ir-chip][data-value="${CSS.escape(value)}"]`);
        if (!real) return;
        mirror.setAttribute("aria-pressed", real.getAttribute("aria-pressed") || "false");
        mirror.disabled = real.disabled;
        mirror.classList.toggle("is-unavailable", real.classList.contains("is-unavailable"));
        mirror.setAttribute("aria-label", real.getAttribute("aria-label") || value);
      });
    };

    optionSelects.forEach((s) => s.addEventListener("change", () => sync(true)));

    // Registered before the bag's submit handler, so a missing size stops the add.
    if (productForm && atc) {
      productForm.addEventListener("submit", (e) => {
        if (!atc.dataset.needSize) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (sizeNeed) sizeNeed.hidden = false;
        const stickyBar = document.querySelector("[data-ir-sticky-atc]");
        const stickyOpen = stickyBar && stickyBar.classList.contains("is-visible");
        if (stickyOpen) stickyBar.classList.add("is-needed");
        if (sizeGroup) {
          sizeGroup.classList.add("is-needed");
          if (!stickyOpen) {
            sizeGroup.scrollIntoView({ behavior: "smooth", block: "center" });
            const first = sizeGroup.querySelector("[data-ir-chip]:not([disabled])");
            if (first) first.focus({ preventScroll: true });
          }
        }
      });
    }

    const stickySizes = document.querySelector("[data-ir-sticky-sizes]");
    if (stickySizes && sizeGroup && !stickySizes.childElementCount) {
      sizeGroup.querySelectorAll("[data-ir-chip]").forEach((chip) => {
        const mirror = document.createElement("button");
        mirror.type = "button";
        mirror.className = "ir-chip";
        mirror.setAttribute("data-ir-sticky-chip", "");
        mirror.setAttribute("data-value", chip.getAttribute("data-value") || "");
        mirror.innerHTML = chip.innerHTML;
        mirror.addEventListener("click", () => chip.click());
        stickySizes.appendChild(mirror);
      });
    }

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        const optIndex = Number(chip.getAttribute("data-option-index") || "0");
        const value = chip.getAttribute("data-value") || "";
        const select = Array.from(optionSelects).find(
          (s) => Number(s.getAttribute("data-index")) === optIndex
        );
        if (!select) return;
        select.value = value;
        const group = chip.closest("[data-ir-option-group]");
        if (group) {
          group.querySelectorAll("[data-ir-chip]").forEach((c) => {
            c.setAttribute("aria-pressed", c === chip ? "true" : "false");
          });
        }
        sync(true);
      });
    });

    sync();
  }

  /* ---------- Size guide sheet ---------- */
  const sizeGuide = document.querySelector("[data-ir-size-guide]");
  if (sizeGuide && typeof sizeGuide.showModal === "function") {
    const slot = sizeGuide.querySelector("[data-ir-size-guide-table]");
    const chart = document.querySelector(".ir-details [data-iris-size-guide]");
    if (slot && chart && !slot.childElementCount) {
      const copy = chart.cloneNode(true);
      copy.removeAttribute("data-iris-size-guide");
      const heading = copy.querySelector("h4");
      if (heading) heading.remove();
      slot.appendChild(copy);
    }
    document.querySelectorAll("[data-ir-size-guide-open]").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        sizeGuide.showModal();
      });
    });
    sizeGuide.querySelectorAll("[data-ir-size-guide-close]").forEach((el) => {
      el.addEventListener("click", () => sizeGuide.close());
    });
    sizeGuide.addEventListener("click", (e) => {
      if (e.target === sizeGuide) sizeGuide.close();
    });
  }

  /* ---------- Sticky ATC (IntersectionObserver) ---------- */
  const sticky = document.querySelector("[data-ir-sticky-atc]");
  const form = document.getElementById("IrProductForm");
  const stickyBtn = document.querySelector("[data-ir-sticky-submit]");
  if (sticky && form) {
    const trigger = form.querySelector('[name="add"], button[type="submit"]');
    const setVisible = (show) => {
      sticky.classList.toggle("is-visible", show);
      sticky.setAttribute("aria-hidden", show ? "false" : "true");
    };
    if (stickyBtn && trigger) {
      stickyBtn.addEventListener("click", () => {
        if (trigger.disabled) return;
        trigger.click();
      });
    }
    if ("IntersectionObserver" in window && trigger) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => setVisible(!entry.isIntersecting));
        },
        { rootMargin: "0px 0px -12% 0px", threshold: 0 }
      );
      io.observe(trigger);
    } else {
      const buy = form.querySelector(".ir-buy");
      const onScroll = () => {
        if (!buy) return;
        setVisible(buy.getBoundingClientRect().bottom < 0);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    form.addEventListener("submit", () => {
      if (!trigger || trigger.disabled) return;
      trigger.classList.add("is-loading");
      trigger.setAttribute("aria-busy", "true");
    });
  }

  /* ---------- Slide-in bag ---------- */
  const bag = document.querySelector("[data-ir-bag]");
  if (bag && window.fetch && !document.body.classList.contains("template-cart")) {
    const SECTION = "ir-cart-drawer";
    const panel = bag.querySelector(".ir-bag__panel");
    const bagLink = document.querySelector("[data-ir-bag-link]");
    let lastFocus = null;
    let hideTimer = 0;

    const added = document.querySelector("[data-ir-added]");
    const hideAdded = () => {
      if (!added) return;
      added.classList.remove("is-open");
      added.hidden = true;
    };
    const showAdded = (json) => {
      if (!added) {
        openDrawer();
        return;
      }
      hideTimer && clearTimeout(hideTimer);
      const title = added.querySelector("[data-ir-added-title]");
      const variant = added.querySelector("[data-ir-added-variant]");
      const img = added.querySelector("[data-ir-added-img]");
      const checkout = added.querySelector("[data-ir-added-checkout]");
      const drawerCheckout = bag.querySelector(".ir-cart-checkout");
      if (title) title.textContent = json.product_title || json.title || "Added";
      if (variant) {
        const label = json.variant_title && json.variant_title !== "Default Title" ? json.variant_title : "";
        variant.textContent = label;
        variant.hidden = !label;
      }
      if (img) {
        const src = typeof json.image === "string" ? json.image : (json.image && (json.image.src || json.image.url)) || "";
        if (src) img.src = src;
      }
      if (checkout && drawerCheckout) checkout.textContent = (drawerCheckout.textContent || "Check out").trim();
      added.hidden = false;
      requestAnimationFrame(() => added.classList.add("is-open"));
      if (checkout) checkout.focus({ preventScroll: true });
    };
    const openDrawer = () => {
      hideAdded();
      clearTimeout(hideTimer);
      lastFocus = document.activeElement;
      bag.hidden = false;
      requestAnimationFrame(() => bag.classList.add("is-open"));
      document.documentElement.classList.add("ir-bag-open");
      const checkout = bag.querySelector(".ir-cart-checkout");
      (checkout || panel).focus({ preventScroll: true });
    };
    const closeDrawer = () => {
      bag.classList.remove("is-open");
      document.documentElement.classList.remove("ir-bag-open");
      hideTimer = setTimeout(() => { bag.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    const updateBag = (count) => {
      if (!bagLink) return;
      bagLink.innerHTML = count > 0 ? `Bag<span class="ir-header__cart-count">${count}</span>` : "Bag";
      bagLink.setAttribute("aria-label", count > 0 ? `Bag, ${count} item${count === 1 ? "" : "s"}` : "Bag");
    };
    const render = (sections) => {
      const html = sections && sections[SECTION];
      if (!html) return false;
      const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-ir-bag-body]");
      const body = bag.querySelector("[data-ir-bag-body]");
      if (!fresh || !body) return false;
      body.replaceWith(fresh);
      updateBag(Number(fresh.dataset.count || 0));
      return true;
    };
    const refresh = async () => {
      try {
        const res = await fetch(`${window.location.pathname}?sections=${SECTION}`, { headers: { Accept: "application/json" } });
        if (res.ok) render(await res.json());
      } catch {}
    };

    bag.addEventListener("click", async (e) => {
      if (e.target.closest("[data-ir-bag-close]")) {
        closeDrawer();
        return;
      }
      const qty = e.target.closest("[data-ir-bag-qty]");
      if (!qty) return;
      e.preventDefault();
      if (qty.getAttribute("aria-busy") === "true") return;
      qty.setAttribute("aria-busy", "true");
      const item = qty.closest(".ir-bag__item");
      const err = item && item.querySelector(".ir-bag__err");
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: Number(qty.dataset.irBagQty), quantity: Number(qty.dataset.qty), sections: SECTION }),
        });
        const json = await res.json();
        if (!res.ok) {
          qty.removeAttribute("aria-busy");
          if (err) {
            err.textContent = json.description || json.message || "Couldn't change that — try again.";
            err.hidden = false;
          }
          return;
        }
        if (!render(json.sections)) window.location.href = qty.href;
      } catch {
        window.location.href = qty.href;
      }
    });
    if (added) {
      added.addEventListener("click", (e) => {
        if (e.target.closest("[data-ir-added-close]")) hideAdded();
      });
      document.addEventListener("click", (e) => {
        if (added.hidden || added.contains(e.target)) return;
        if (e.target.closest("#IrProductForm, [data-ir-sticky-submit]")) return;
        hideAdded();
      });
    }
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (added && !added.hidden) hideAdded();
      else if (!bag.hidden) closeDrawer();
    });
    if (bagLink) {
      bagLink.addEventListener("click", (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        openDrawer();
      });
    }
    window.addEventListener("pageshow", (e) => { if (e.persisted) refresh(); });

    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[name="add"]');
        let err = form.querySelector(".ir-atc-error");
        if (err) err.hidden = true;
        const done = () => {
          if (!btn) return;
          btn.classList.remove("is-loading");
          btn.removeAttribute("aria-busy");
        };
        const fd = new FormData(form);
        fd.append("sections", SECTION);
        fd.append("sections_url", window.location.pathname);
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            body: fd,
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          });
          const json = await res.json();
          done();
          if (!res.ok) {
            if (!err) {
              err = document.createElement("p");
              err.className = "ir-atc-error";
              err.setAttribute("role", "alert");
              const buy = form.querySelector(".ir-buy");
              if (buy) buy.after(err);
              else form.appendChild(err);
            }
            err.textContent = json.description || json.message || "Couldn't add that size — try another.";
            err.hidden = false;
            return;
          }
          render(json.sections);
          window.location.href = "/checkout";
        } catch {
          done();
          form.submit();
        }
      });
    }

    document.addEventListener("ir:added", (e) => {
      const sections = e.detail && e.detail.sections;
      if (render(sections)) openDrawer();
    });
  }

  /* ---------- Welcome offer ---------- */
  const welcome = document.querySelector("[data-ir-welcome]");
  if (welcome) {
    const KEY = "ir_welcome_seen";
    const AD_KEY = "ir_welcome_ad";
    // Retargeting links carry their own code; the pop-up's auto-apply would replace it.
    if (/[?&]utm_content=retarget/.test(location.search)) {
      try { localStorage.setItem(KEY, String(Date.now())); } catch {}
    }
    // Paid arrivals already have the offer in the ad. Don't cover the product.
    if (/[?&](utm_medium=paid|utm_source=meta|utm_source=facebook|utm_source=ig|fbclid=)/i.test(location.search)) {
      try { sessionStorage.setItem(AD_KEY, "1"); } catch {}
    }
    let adVisit = false;
    try { adVisit = sessionStorage.getItem(AD_KEY) === "1"; } catch {}
    const open = () => {
      const root = document.documentElement.classList;
      if (!welcome.hidden || welcome.dataset.closed || root.contains("ir-bag-open") || root.contains("ir-lightbox-open")) return;
      welcome.hidden = false;
      document.documentElement.classList.add("ir-welcome-open");
    };
    const close = () => {
      welcome.dataset.closed = "1";
      welcome.hidden = true;
      document.documentElement.classList.remove("ir-welcome-open");
      try { localStorage.setItem(KEY, String(Date.now())); } catch {}
    };
    welcome.querySelectorAll("[data-ir-welcome-close]").forEach((el) => el.addEventListener("click", close));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !welcome.hidden) close(); });
    const posted = welcome.querySelector("[data-ir-welcome-posted]");
    if (posted?.dataset.code) {
      fetch(`/discount/${encodeURIComponent(posted.dataset.code)}`, { credentials: "same-origin" }).catch(() => {});
    }
    if (adVisit) {
      // Stay closed for the rest of this visit, including the next page.
    } else if (posted || welcome.querySelector(".ir-welcome__err")) {
      open();
    } else {
      let seen = 0;
      let views = 1;
      try {
        seen = Number(localStorage.getItem(KEY) || 0);
        views = Number(sessionStorage.getItem("ir_views") || 0) + 1;
        sessionStorage.setItem("ir_views", String(views));
      } catch {}
      if (Date.now() - seen > 7 * 24 * 3600 * 1000) {
        // Not on arrival: after 25 s, 6 s into a second page, or when a desktop visitor heads for the tab bar.
        setTimeout(open, views >= 2 ? 6000 : 25000);
        const onLeave = (e) => {
          if (e.relatedTarget || e.clientY > 0) return;
          document.removeEventListener("mouseout", onLeave);
          open();
        };
        if (window.matchMedia("(pointer: fine)").matches) document.addEventListener("mouseout", onLeave);
      }
    }
  }

  /* ---------- Collection quick add. Size is never preselected. ---------- */
  const quickCards = document.querySelectorAll("[data-ir-quick-open], [data-ir-quick-direct]");
  if (quickCards.length && window.fetch) {
    const addVariant = async (id, button) => {
      button.classList.add("is-loading");
      button.setAttribute("aria-busy", "true");
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            id: Number(id),
            quantity: 1,
            sections: "ir-cart-drawer",
            sections_url: window.location.pathname,
          }),
        });
        const json = await res.json();
        button.classList.remove("is-loading");
        button.removeAttribute("aria-busy");
        if (!res.ok) {
          const card = button.closest(".ir-tile");
          let err = card && card.querySelector(".ir-quick__need");
          if (err) {
            err.hidden = false;
            err.textContent = json.description || json.message || "Couldn't add that — try again.";
          }
          return;
        }
        if (!(json.sections && json.sections["ir-cart-drawer"])) {
          window.location.href = "/cart";
          return;
        }
        document.dispatchEvent(new CustomEvent("ir:added", { detail: json }));
        const panel = button.closest("[data-ir-quick]");
        if (panel) {
          panel.hidden = true;
          const opener = panel.parentElement && panel.parentElement.querySelector("[data-ir-quick-open]");
          if (opener) opener.setAttribute("aria-expanded", "false");
        }
      } catch {
        button.classList.remove("is-loading");
        button.removeAttribute("aria-busy");
        window.location.href = "/cart";
      }
    };

    document.querySelectorAll("[data-ir-quick-direct]").forEach((button) => {
      button.addEventListener("click", () => addVariant(button.getAttribute("data-ir-quick-direct"), button));
    });

    document.querySelectorAll("[data-ir-quick-open]").forEach((button) => {
      button.addEventListener("click", () => {
        const card = button.closest(".ir-tile");
        const panel = card && card.querySelector("[data-ir-quick]");
        if (!panel) return;
        const open = panel.hidden;
        document.querySelectorAll("[data-ir-quick]").forEach((other) => {
          other.hidden = true;
        });
        document.querySelectorAll("[data-ir-quick-open]").forEach((other) => {
          other.setAttribute("aria-expanded", "false");
        });
        panel.hidden = !open;
        button.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    document.querySelectorAll("[data-ir-quick]").forEach((panel) => {
      let variants = [];
      try {
        variants = JSON.parse((panel.querySelector("[data-ir-quick-json]") || {}).textContent || "[]");
      } catch {
        variants = [];
      }
      const go = panel.querySelector("[data-ir-quick-go]");
      const need = panel.querySelector("[data-ir-quick-need]");
      const sync = () => {
        const groups = Array.from(panel.querySelectorAll("[data-ir-quick-group]"));
        const chosen = groups.map((group) => {
          const pressed = group.querySelector('[aria-pressed="true"]');
          return pressed ? pressed.getAttribute("data-value") : "";
        });
        const indexes = groups.map((group) => Number(group.getAttribute("data-index")));
        const complete = chosen.every(Boolean);
        if (need && complete) need.hidden = true;
        if (!go) return;
        if (!complete) {
          go.dataset.needChoice = "1";
          go.textContent = panel.querySelector("[data-ir-quick-size]") ? "Choose your size" : "Choose one";
          return;
        }
        const match = variants.find((v) => indexes.every((idx, i) => String(v.o[idx]) === chosen[i]));
        if (!match || !match.ok) {
          delete go.dataset.needChoice;
          delete go.dataset.variantId;
          go.textContent = "Sold out";
          return;
        }
        delete go.dataset.needChoice;
        go.dataset.variantId = String(match.id);
        go.textContent = "Add to bag";
      };
      panel.querySelectorAll("[data-ir-quick-chip]").forEach((chip) => {
        chip.addEventListener("click", () => {
          if (chip.disabled) return;
          const group = chip.closest("[data-ir-quick-group]");
          group.querySelectorAll("[data-ir-quick-chip]").forEach((other) => {
            other.setAttribute("aria-pressed", other === chip ? "true" : "false");
          });
          sync();
        });
      });
      if (go) {
        go.addEventListener("click", () => {
          sync();
          if (go.dataset.needChoice) {
            if (need) need.hidden = false;
            const size = panel.querySelector("[data-ir-quick-size]");
            const first = (size || panel).querySelector("[data-ir-quick-chip]:not([disabled])");
            if (first) first.focus();
            return;
          }
          if (!go.dataset.variantId) return;
          addVariant(go.dataset.variantId, go);
        });
      }
      sync();
    });
  }
})();
